import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import RenderCard from '../components/RenderCard';
import CommissionForm from '../components/CommissionForm';
import { fetchRecentRenders } from '../api/renders';
import '../styles/HomePage.css';

const HomePage = () => {
  const [renders, setRenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadRenders = async () => {
      try {
        const data = await fetchRecentRenders();
        setRenders(data);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch renders:', err);
        setError('Failed to load recent works. Please try again later.');
        setLoading(false);
      }
    };

    loadRenders();
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Bishop Pixel Studio</h1>
          <p>Bringing imagination to life through Blender renders and 3D artistry</p>
          <a href="#gallery" className="cta-button">
            Explore Works
          </a>
        </div>
        <div className="hero-backdrop"></div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="gallery-section">
        <div className="section-header">
          <h2>Recent Works</h2>
          <div className="accent-line"></div>
        </div>

        {loading ? (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading gallery...</p>
          </div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : (
          <>
            <div className="gallery-grid">
              {renders.map(render => (
                <RenderCard key={render.id} render={render} />
              ))}
            </div>
            
            {renders.length > 0 && (
              <div className="view-all-container">
                <Link to="/gallery" className="view-all-button">
                  View All Works
                </Link>
              </div>
            )}
          </>
        )}
      </section>

      {/* Commission Section */}
      <section id="commission-section" className="commission-section">
        <div className="section-header">
          <h2>Request a Commission</h2>
          <div className="accent-line"></div>
        </div>
        
        <div className="commission-content">
          <div className="commission-info">
            <h3>Work with Me</h3>
            <p>
              Interested in a custom 3D render or design? I'm available for commissions ranging from character models to architectural visualizations.
            </p>
            <ul className="commission-benefits">
              <li>Custom conceptualization and design</li>
              <li>Regular updates and revision opportunities</li>
              <li>High-resolution final renders</li>
              <li>Personal usage rights for the commissioned work</li>
            </ul>
            <p className="commission-note">
              Fill out the form to discuss your project needs and get a quote.
            </p>
          </div>
          
          <CommissionForm />
        </div>
      </section>
    </div>
  );
};

export default HomePage;